import React from 'react'
import loader from "../assests/images/loader.gif"

function Loader() {
  return (
   
        <img src={loader} alt="Loading..."  
            style={{
                width: '100px',
                height: '100px',
                margin: 'auto',
                display: 'block',
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
            }}
        />
    
  )
}

export default Loader


// WEBPACK FOOTER //
// ./src/components/Loader.js